import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Tells a CSG node whether an ancestor's boolean absorbed its solid. A skipped
 * child would lose selection and the hidden toggle, so it stays mounted and drops
 * its own mesh. Keyed by path, since Godot sets `parent_shape` only for a direct
 * CSG parent: `CSGBox3D > Node3D > CSGSphere3D` is two roots.
 */
import { createContext, useContext } from 'react';
const CsgSubtreeContext = createContext(null);
CsgSubtreeContext.displayName = 'CsgSubtreeContext';
export function CsgSubtreeProvider({ value, children }) {
    return _jsx(CsgSubtreeContext.Provider, { value: value, children: children });
}
/** The enclosing CSG root's state, or null outside one. */
export function useCsgSubtree() {
    return useContext(CsgSubtreeContext);
}
//# sourceMappingURL=CsgSubtreeContext.js.map